import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, Treemap } from 'recharts';

const COLORS = [
  '#f2e3e3',
  '#cee9cf',
  '#def0df',
  '#f6dbc9',
  '#d2e5ef',
  '#cec6ef',
  '#e2def1',
  '#fcefb4'
];

const CustomizedContent = ({
  root,
  depth,
  x,
  y,
  width,
  height,
  index,
  colors,
  name,
  size,
  dataKey
}) => {
  if (!isNaN(x) && !isNaN(y)) {
    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: depth < 2 ? colors[index] : 'none',
            stroke: '#fff',
            strokeWidth: 2 / (depth + 1e-10),
            strokeOpacity: 1 / (depth + 1e-10)
          }}
        />
        {depth === 1 ? (
          <text
            x={x + width / 2}
            y={y + height / 2 + 7}
            textAnchor="middle"
            fontSize={11}>
            {name} :{' '}
            {root.children[index][dataKey]
              ? root.children[index][dataKey]
              : size}
          </text>
        ) : null}
      </g>
    );
  }

  return null;
};

const SimpleTreemap = ({ data, dataKey }) => {
  let randomColors = [];
  for (let i = 0; i < data.length; i++) {
    randomColors.push(COLORS[Math.floor(Math.random() * COLORS.length)]);
  }

  return (
    <ResponsiveContainer height={260}>
      <Treemap
        isAnimationActive={false}
        animationDuration={0}
        width={400}
        height={200}
        data={data}
        dataKey={dataKey}
        stroke="#556069"
        fill="#8884d8"
        content={
          <CustomizedContent colors={randomColors} dataKey={dataKey} />
        }></Treemap>
    </ResponsiveContainer>
  );
};

SimpleTreemap.propTypes = {
  data: PropTypes.array.isRequired,
  dataKey: PropTypes.string.isRequired
};

export default SimpleTreemap;
